module.exports = __webpack_public_path__ + "img/mtn.6df862bb.png";